// extracted by mini-css-extract-plugin
export default {"root":"AdvertCardList_root__WppCB","list":"AdvertCardList_list__mwMdM"};